<template>
    <div class="dashboard__view">
        <div class="page">
            <div class="page__title">Banks</div>
        </div>

        <div @click="$router.go(-1)" class="page__nav">
            <div class="page__nav__icon">
                <svg fill="none" height="16" viewBox="0 0 19 16" width="19" xmlns="http://www.w3.org/2000/svg">
                    <path d="M19 7L4.92969 7L9.5 2.42969L8 0.929687L0.929687 8L8 15.0703L9.5 13.5703L4.92969 9L19 9L19 7Z" fill="#655D79" />
                </svg>
            </div>
            <div class="page__nav__text">Bank Details</div>
        </div>

        <div class="details">
            <div class="details__card">
                <div class="details__card__container">
                    <div class="details__card__header">Details</div>
                    <div class="details__card__item">
                        <div class="details__card__item__left">
                            <div class="details__card__item__label">Bank Code</div>
                            <div class="details__card__item__value">{{bankDetails.code}}</div>
                        </div>
                        <div class="details__card__item__right">
                            <div class="details__card__item__label">Short Name</div>
                            <div class="details__card__item__value">{{bankDetails.cbncode}}</div>
                        </div>
                    </div>
                    <div class="details__card__item" v-if="bankDetails.enabled_info">
                        <div class="details__card__item__left">
                            <div class="details__card__item__label">API_secret</div>
                            <div class="details__card__item__value">{{bankDetails.enabled_info.api_secret}}</div>
                        </div>
                        <div class="details__card__item__right visible-no">
                            <div class="details__card__item__label">.</div>
                        </div>
                    </div>
                    <div class="details__card__item" v-if="bankDetails.enabled_info">
                        <div class="details__card__item__left">
                            <div class="details__card__item__label">API Key</div>
                            <div class="details__card__item__value">{{bankDetails.enabled_info.api_key}}</div>
                        </div>
                        <div class="details__card__item__right visible-no">
                            <div class="details__card__item__label">.</div>
                        </div>
                    </div>
                    <div class="details__card__item" v-if="bankDetails.enabled_info">
                        <div class="details__card__item__left">
                            <div class="details__card__item__label">Bank Fee Nuban</div>
                            <div class="details__card__item__value">{{bankDetails.enabled_info.meta.bank_fee_account}}</div>
                        </div>
                        <div class="details__card__item__right">
                            <div class="details__card__item__label">Woven Fee Nuban</div>
                            <div class="details__card__item__value">{{bankDetails.enabled_info.meta.woven_fee_account}}</div>
                        </div>
                    </div>
                    <div class="details__card__item">
                        <div class="details__card__item__left">
                            <div class="details__card__item__label">Name of Bank</div>
                            <div class="details__card__item__value">{{bankDetails.bank}}</div>
                        </div>
                        <div class="details__card__item__right visible-no">
                            <div class="details__card__item__label">.</div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- <div class="details__trail"></div> -->
        </div>
    </div>
</template>

<script>
export default {
    metaInfo: {
        title: "Bank Details",
    },
    data() {
        return {
            bankDetails: {},
            merchantDetails: {},
        };
    },

    created() {
        this.fetchBankDetail();
    },

    methods: {
        fetchBankDetail() {
            this.$http.get(`admin/banks?index=${this.$route.params.id}`).then((response) => {
                if (response.body.data.length > 0) {
                    this.bankDetails = response.body.data[this.$route.params.id];

                    // if (typeof this.bankDetails.enabled_info !== "undefined") {
                    //     this.fetchMerchants(this.bankDetails.enabled_info.id);
                    // }
                }
            });
        },

        fetchMerchants(value) {
            this.$http.get(`admin/merchants?merchantId=${value}`).then((response) => {
                if (response.body.data.merchants.length > 0) {
                    this.merchantDetails = response.body.data.merchants[0];
                }
            });
        },
    },
};
</script>